<section class="regist-form container-fluid">
  <div class="row m-auto">


    <div class="img-regist">
      <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
          <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item ci1 w-100 active">
            <img src="./assets/6.png" class="d-block w-100 h-100" alt="...">
          </div>
          <div class="carousel-item ci2 w-100">
            <img src="./assets/9.png" class="d-block w-100 h-100" alt="...">
          </div>
          <div class="carousel-item ci3 w-100">
            <img src="./assets/10.png" class="d-block w-100 h-100" alt="...">
          </div>
        </div>
      </div>
    </div>


    <form class=" signup-form" [formGroup]="registForm" (ngSubmit)="submitRegisterForm()">
      <div class="cont">
        <div class="pro">
          <h2 class="text-center">Sign Up</h2>
          <p class="text-center">Welcome To Your Dream's Kichen...</p>
        </div>
        <div class="mb-1">
          <input type="email" placeholder="EMAIL ADDRESS..." formControlName="Email" class="form-control m-0"
            id="exampleInputEmail1" aria-describedby="emailHelp">
          <div class="validat-txxt" *ngIf="registControls.Email.errors && registControls.Email.touched">
            <div *ngIf="registControls.Email.errors.required">
              <div class="validat-txt text-center m-auto">This feild is required</div>
            </div>
            <div *ngIf="registControls.Email.errors?.pattern">
              <div class="validat-txt text-center m-auto">invalid Pattern</div>
            </div>
          </div>
        </div>
        <div class="mb-1">
          <input type="password" placeholder="PASSWORD..." formControlName="Pass" class="form-control m-0" id="pass">
          <div *ngIf="registControls.Pass.errors && registControls.Pass.touched">
            <div *ngIf="registControls.Pass.errors.required">
              <div class="validat-txt text-center m-auto">This feild is required</div>
            </div>
            <div *ngIf="registControls.Pass.errors.minlength">
              <div class="validat-txt text-center m-auto">at least 8 characters</div>
            </div>
          </div>
        </div>
        <div class="mb-1">
          <input type="password" placeholder="CONFIRM PASSWORD..." formControlName="confirmPass"
            class="form-control m-0" id="confirmPass">
          <div *ngIf="registControls.confirmPass.errors && registControls.confirmPass.touched">
            <div *ngIf="registControls.confirmPass.errors.required">
              <div class=" validat-txt text-center m-auto">This feild is required</div>
            </div>
          </div>
        </div>
        <button type="submit" class="reg-btn btn btn-primary">Register</button>
        <h5 class="text-danger mt-2">{{firebaseError}}</h5>
      </div>
    </form>

  </div>
</section>